export default "__VITE_ASSET__DGJoo$Ek__"